import React from "react";

class DDadosComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <span>{this.props.Label}</span>;
  }
}

export default DDadosComponent;
